
// 常规页面
import PageIndex from '@/views/pages/index'
import Home from '@/views/pages/home'
import Store from '@/views/pages/store'
import StoreList from '@/views/pages/storeList'
import Search from '@/views/pages/search'
import QuickBuy from '@/views/pages/quickBuy'
import goodsDetail from '@/views/pages/goodsDetail'


export default [

    {path: '',component:PageIndex, name: 'page',children: [
        {path: '/',component:Home, name: 'home'},
        {path: '/store',component:Store, name: 'store'},
        {path: '/storeList',component:StoreList, name: 'storeList'},
        {path: '/search',component:Search, name: 'search'},
        {path: '/buy',component:QuickBuy, name: 'buy'},
        {path: '/goodsDetail',component:goodsDetail, name: 'goodsDetail'},
    ],redirect: '/'},

]




// WEBPACK FOOTER //
// ./src/router/page.js